export default __webpack_public_path__ + "assets/marker-shadow.a0c6cc14.png";